module.exports = __webpack_public_path__ + "static/media/onlyCat.498b74ea.png";